import React from 'react';
import { Button } from 'components';
import { Link } from '@material-ui/icons';
import { toast } from 'react-toastify';
import environment from 'environments/environment';
import { IInspection } from 'pages/SchedulerList/components/Inspection/Inspection.types';

interface INewLinkActionProps {
  inspection: IInspection;
}

const NewLinkAction = ({ inspection }: INewLinkActionProps) => {
  const handleCopyNewLink = async () => {
    try {
      toast.dismiss();
      if (!!environment.WEBAPP_URL && !!inspection.id) {
        const webappLink = environment.WEBAPP_URL + inspection.id + '&ap=true';
        await navigator.clipboard.writeText(webappLink);
        toast.success('Novo link copiado para área de transferência.');
      } else {
        toast.error('Ocorreu um erro ao montar o link. Por favor, tente novamente.');
      }
    } catch (error) {
      toast.error('Ocorreu um erro ao copiar o link. Por favor, tente novamente.');
    }
  };

  const hasPhotos = inspection.photos && inspection.photos.length > 0;

  return hasPhotos ? (
    <Button
      type="button"
      testID="new-link-action"
      text="NOVO LINK"
      size="small"
      onClick={handleCopyNewLink}
      startIcon={<Link />}
      variant="outlined"
    />
  ) : null;
};

export default NewLinkAction;
